// Klavio Custom Show Popup after page load
window.addEventListener("load", function (event) {
  
  var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };
  if(getUrlParameter('show_klaviyo_popup') === "1") {
      console.log("red");
      document.querySelector('.klaviyo-bis-trigger').click();
  }
});

// JavaScript to make the button sticky for mobile devices (max-width: 999px)
document.addEventListener('DOMContentLoaded', function() {
      const button = document.querySelector('.product-info .buy-buttons') ? document.querySelector('.product-info .buy-buttons') : '';
      
      if (button){
        const button_select_size = button.querySelector('.button--select-size');
        const button_height = button_select_size.getBoundingClientRect().height;
  
        if (button && button_select_size){
         button_select_size.addEventListener('click', function() {
            if (window.innerWidth <= 999) {
              const targetScrollTop = document.querySelector('[data-block-type="buy-buttons"]').getBoundingClientRect().bottom + window.scrollY - window.innerHeight + button_height;
              // Scroll the window to the target position smoothly
              window.scrollTo({
                  top: targetScrollTop,
                  behavior: 'smooth'
              });
  
            }
        });
      }
        
      // Check if the viewport width is less than or equal to 999 pixels
      if (window.innerWidth <= 999) {
          
          const interactElement = button.querySelector('.interact-js');
          // Function to toggle the 'sticky' class based on scroll position
          function toggleStickyClass() {
              const buttonPosition = button.getBoundingClientRect();
              if (buttonPosition.top >= window.innerHeight - button_height || buttonPosition.bottom + button_height <= 0) {
                  button.classList.add('sticky');
                  button.classList.remove('non-sticky');
                  interactElement.style.height = button_height + 'px'; // Set height to button height when sticky
                  document.querySelector('.shopify-section--footer').style.paddingBottom = button_height + 'px';
              } else {
                  button.classList.remove('sticky');
                  button.classList.add('non-sticky');
                  interactElement.style.height = '0'; // Set the height to 0 when non-sticky
                  document.querySelector('.shopify-section--footer').style.paddingBottom = '0';
              }
          }
  
          // Initial call to set the class based on the initial position
          toggleStickyClass();
  
          // Add a scroll event listener to toggle the class on scroll
          window.addEventListener('scroll', toggleStickyClass);
  
          // Add a resize event listener to reevaluate when the window is resized
          window.addEventListener('resize', toggleStickyClass);
      } else {
        // const interactElement = button.querySelector('.interact-js');
        button.classList.remove('sticky');
        button.classList.add('non-sticky');
        // interactElement.style.height = '0'; // Set the height to 0 when non-sticky
        document.querySelector('.shopify-section--footer').style.paddingBottom = '0';
      }
      
  }

  
    
});
  
  function productCardShowcase() {
    const productCards = document.querySelectorAll('.product-card__quick-add-block');
  
      console.log('[PRODUCTS]',productCards);
      // Add hover behavior for each product card
      productCards.forEach(function(card) {
          const checkbox = card.querySelector('.product-card__quick-add-block-checkbox');
          
          card.addEventListener('mouseover', function() {
            console.log('HOVER');
              checkbox.checked = true;  // Check the checkbox on hover
          });
  
          card.addEventListener('mouseout', function() {
              checkbox.checked = false; // Uncheck the checkbox when mouse leaves
          });
      });
  }
   // Trigger form submission when clicking on product-card__btn-for-form label
  document.addEventListener('DOMContentLoaded', function() {
    const labels = document.querySelectorAll('.product-card__btn-for-form');
    
    labels.forEach(function(label) {
      label.addEventListener('click', function(e) {
        // Find the form associated with this label
        const wrapper = this.closest('.product-card__btn-for-form-wrapper');
        if (wrapper) {
          const form = wrapper.querySelector('.product-card__quick-add-buttons-form');
          if (form) {
            const submitButton = form.querySelector('.product-card__quick-add-buttons-form-button');
            if (submitButton && !submitButton.classList.contains('is-disabled')) {
              // Use setTimeout to allow the label's default behavior (checking radio) to complete first
              setTimeout(function() {
                form.requestSubmit(submitButton);
              }, 0);
            }
          }
        }
      });
    });
  });
  accordionControls();

function accordionControls() {

    var t = document.querySelectorAll(".accordion-toggle")
      , e = document.querySelectorAll(".accordion-content .close-accordion")
      , r = document.querySelector(".product-info")
      , i = document.querySelectorAll(".mob-accordion-toggle")
      , n = document.querySelectorAll(".js-swap-measure")
      , active = false;
      
    t.forEach((function(t) {
        t.removeEventListener("click", (function(t) {}
        )),
        document.body.removeEventListener("click", (function(t) {}
        )),
        t.addEventListener("click", (function(t) {
            document.body.addEventListener('click', function (event) {
                if (!event.target.closest('.accordion-content') && !event.target.closest('.product-accordion-wrapper')) {
                  document.querySelector('.accordion-content.active .close-accordion')?.click();
                } 
            });
            t.preventDefault();
            var e, i = this, n = this.getAttribute("data-accordion"), a = document.querySelectorAll(".accordion-toggle"), s = document.querySelectorAll(".accordion-content"), o = this.classList.contains("for-mobile-size-guide");
            e = o && window.innerWidth <= 1023 ? document.querySelectorAll('.mobile-size-guide .accordion-content[data-accordion="'.concat(n, '"]')) : document.querySelectorAll('.accordion-content[data-accordion="'.concat(n, '"]')),
            a.forEach((function(e) {
                e != i && ("4" == t.target.dataset.accordion && window.innerWidth <= 1023 || e.classList.remove("active"))
            }
            )),
            s.forEach((function(r) {
                e.forEach((function(e) {
                    e != r && ("4" == t.target.dataset.accordion && window.innerWidth <= 1023 || r.classList.remove("active")),
                    e.classList.contains("accordion-side") && window.innerWidth <= 1023 && document.body.classList.remove("msize-active")
                }
                ))
            }
            )),
            this.classList.contains("active") ? (this.classList.remove("active"),
            e.forEach((function(t) {
                t && (t.classList.remove("active"),
                window.innerWidth > 1023 && r.classList.remove("accordion-active"),
                t.classList.contains("accordion-side") && window.innerWidth <= 1023 && document.body.classList.remove("msize-active"))
            }
            ))) : (this.classList.add("active"),
            document.querySelector("html").classList.add("max-md:overflow-hidden"),
            e.forEach((function(t) {
                t && (t.classList.add("active"),
                window.innerWidth > 1023 && r.classList.add("accordion-active"),
                t.classList.contains("accordion-side") && window.innerWidth <= 1023 && document.body.classList.add("msize-active"))
            }
            )))
        }
        ))
    }
    )),
    e.forEach((function(t, e) {
        t.addEventListener("click", (function(t) {

            t.preventDefault();
            var e = this.closest(".accordion-content")
              , i = e.getAttribute("data-accordion");
            e.classList.contains("active") && (e.classList.contains("accordion-side") && window.innerWidth <= 1023 && document.body.classList.remove("msize-active"),
            e.classList.remove("active")),
            document.querySelector('.accordion-toggle[data-accordion="'.concat(i, '"]')).classList.contains("active") && document.querySelector('.accordion-toggle[data-accordion="'.concat(i, '"]')).classList.remove("active"),
            r.classList.remove("accordion-active"),
            document.querySelector("html").classList.remove("max-md:overflow-hidden");
            var a = new Event("change",{
                bubbles: !0,
                cancelable: !0
            });
            setTimeout((function() {
                n.forEach((function(t) {
                    t.dispatchEvent(a),
                    t.checked = !1
                }
                ))
            }
            ), 100)
        }
        ))
    }
    )),
    i.forEach((function(t) {
        t.addEventListener("click", (function(t) {
            t.preventDefault();
            var e = this.closest(".accordion-content");
            e.classList.contains("active") ? e.classList.remove("active") : e.classList.add("active")
        }
        ))
    }
    ));
    var a = document.querySelector(".mobile-size-guide .bg-filter");
    a && a.addEventListener("click", (function() {
        this.parentElement.querySelector(".close-accordion").click()
    }
    ))
}